import React, {useEffect, useLayoutEffect} from 'react';
import useGetCheckOrderData from "@CheckOrder/hooks/useGetCheckOrderData";
import useCheckOrderLandingEvent from "@CheckOrder/hooks/useCheckOrderLandingEvent";
import FullScreenLoader from "@Generic/loaders/FullScreenLoader";
import {googleTagManagerSelectItemEvent} from "@CheckOrder/functions/googleTagManager";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "@Features/stripe/components/CheckoutForm";
import IconPoweredByStripe from "@Icons/IconPoweredByStripe";
import useLocale from "@Hooks/selector/useLocale";
import PaymentInfoSection from "@CheckOrder/features/paymentSummary/components/PaymentInfoSection";
import useCheckOrderStripe from "@CheckOrder/hooks/useCheckOrderStripe";
import CheckOrderSidebar from "@CheckOrder/components/Sidebar/CheckOrderSidebar";
import CheckOrderMainSection from "@CheckOrder/components/MainSection/CheckOrderMainSection";
import CheckOrderModals from "@CheckOrder/features/modals/components/CheckOrderModals";
import CheckOrderTitleContainer from "@CheckOrder/components/Title/CheckOrderTitleContainer";
import dismissPlaceholders from "@Features/domElements/functions/dismissPlaceholders";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {useScrollToTopOnMount} from "@Scroll/hooks/useScrollToTopOnMount";
import useScrollToTopOnSafari from "@Hooks/effects/useScrollToTopOnSafari";

function CheckOrder() {
    useLayoutEffect(() => {
        dismissPlaceholders()
    }, [])
    useCheckOrderLandingEvent()

    useScrollToTopOnMount()
    useScrollToTopOnSafari()

    const {
        ticket,
        stripeClientSecret,
        stripePublicApiKey,
    } = useGetCheckOrderData();

    const setLocal = useLocale();

    const {
        stripePromise,
        options,
    } = useCheckOrderStripe(stripePublicApiKey, stripeClientSecret, setLocal)

    const isMobile = useIsMobile()

    useEffect(() => {
        if (ticket?.id) {
            googleTagManagerSelectItemEvent(ticket);
        }
    }, [ticket?.id])

    if (!ticket) {
        return (
            <>
                <CheckOrderModals/>
                <FullScreenLoader/>
            </>
        );
    }

    return (
        <div className="gb--check-order">
            <CheckOrderTitleContainer/>
            <div
                className="check-order__container gb--content-with-sidebar"
            >
                {stripeClientSecret ? (
                    <div className="check-order__main">
                        <PaymentInfoSection/>
                        <Elements options={options} stripe={stripePromise}>
                            <CheckoutForm/>
                        </Elements>
                        <IconPoweredByStripe width="125"/>
                    </div>
                ) : (
                    <CheckOrderMainSection
                        seatPickerData={ticket.seatPickerData}
                        hasAddons={!!ticket.addons.singleRouteAddons || !!ticket.addons.returnRouteAddons}
                        isIntermodal={ticket.isIntermodal}
                        additionalTicketFields={ticket.additionalInfoFields}
                        amenities={ticket.amenities}
                        passengerClasses={ticket.passengerClasses}
                    />
                )}
                <CheckOrderModals/>
                {!isMobile && (
                    <CheckOrderSidebar/>
                )}
            </div>
        </div>
    )
}

export default CheckOrder
